export default "__VITE_ASSET__CBdXABzN__";